import validateNumber from 'api/utils/valueFormats/validateNumber'

export type BonusProgramApiResponse = {
    has_active_program: boolean
    monthly_goal?: number
    monthly_deal_count?: number
    bonus_per_deal?: string
}

export type BonusProgram = {
    hasActiveProgram: boolean
    monthlyGoal: number
    monthlyDealCount: number
    bonusPerDeal: number
}

export const EMPTY_PROGRAM: BonusProgram = {
    hasActiveProgram: false,
    monthlyGoal: 0,
    monthlyDealCount: 0,
    bonusPerDeal: 0,
}

export const parseBonusProgram = (
    bonusProgramApiResponse: BonusProgramApiResponse,
): BonusProgram => {
    try {
        return {
            hasActiveProgram: Boolean(
                bonusProgramApiResponse.has_active_program,
            ),
            monthlyGoal: validateNumber(bonusProgramApiResponse.monthly_goal),
            monthlyDealCount: validateNumber(
                bonusProgramApiResponse.monthly_deal_count,
            ),
            bonusPerDeal: validateNumber(
                bonusProgramApiResponse.bonus_per_deal,
            ),
        } as BonusProgram
    } catch {
        return EMPTY_PROGRAM
    }
}
